import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=4a6befec&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=4a6befec&prod&scoped=true&lang=css"
import style1 from "./Create.vue?vue&type=style&index=1&id=4a6befec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6befec",
  null
  
)

export default component.exports